import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { ChipsModule } from "primeng/chips";
import { FileUploadModule } from "primeng/fileupload";
import { AppRoutingModule } from "../app-routing.module";
import { AuthModule } from "../auth/auth.module";
import { UserService } from "../auth/user.service";
import { SharedModule } from "../shared/shared.module";
import { AdminPanelCsvComponent } from "./admin-panel/admin-panel-csv/admin-panel-csv.component";
import { AdminPanelCsvExportFieldsComponent } from "./admin-panel/admin-panel-csv-export-fields/admin-panel-csv-export-fields.component";
import { AdminPanelBulkConfigurationComponent } from "./admin-panel/admin-panel-bulk-configuration/admin-panel-bulk-configuration.component";
import { AdminPanelBulkComponent } from "./admin-panel/admin-panel-bulk/admin-panel-bulk.component";
import { AdminPanelBulkUploadDialogComponent } from "./admin-panel/admin-panel-bulk/admin-panel-bulk-upload-dialog/admin-panel-bulk-upload-dialog.component";
import { AdminPanelFiberHoodContactsComponent } from "./admin-panel/admin-panel-fiber-hood-contacts/admin-panel-fiber-hood-contacts.component";
import { TemplatesOverviewComponent } from "./admin-panel/templates-overview/templates-overview.component";
import { DeleteTemplateDialogComponent } from "./admin-panel/templates-overview/delete-template-dialog/delete-template-dialog.component";
import { OverrideTemplateDialogComponent } from "./admin-panel/templates-overview/override-template-dialog/override-template-dialog.component";
import { AdminPanelTriggerInitialLoadComponent } from "./admin-panel/admin-panel-trigger-initial-load/admin-panel-trigger-initial-load.component";
import { AdminPanelUsersChildComponent } from "./admin-panel/admin-panel-users-child/admin-panel-users-child.component";
import { AdminPanelVerifyMftComponent } from "./admin-panel/admin-panel-verify-mft/admin-panel-verify-mft.component";
import { AdminPanelComponent } from "./admin-panel/admin-panel.component";
import { AreaContactService } from "./admin-panel/services/area-contact.service";
import { ExportFieldService } from "./admin-panel/services/export-fields.service";
import { BulkConfigurationService } from "./admin-panel/services/bulk-configuration.service";
import { BulkService } from "./admin-panel/services/bulk.service";
import { CityListService } from "./admin-panel/services/cityList.service";
import { TemplateService } from "./admin-panel/services/template.service";
import { AddUserComponent } from "./admin-users/admin-add-user/addUser.component";
import { AdminEditUserComponent } from "./admin-users/admin-edit-user/admin-edit-user.component";
import { AdminUsersComponent } from "./admin-users/admin-users.component";
import { BuildingGroupAddBuildingToGroupComponent } from "./building-group/building-group-add-building-to-group/building-group-add-building-to-group.component";
import { BuildingGroupAddBuildingToNewGroupComponent } from "./building-group/building-group-add-building-to-new-group/building-group-add-building-to-new-group.component";
import { BuildingGroupSelectComponent } from "./building-group/building-group-select/building-group-select.component";
import { RemoveGroupFromBuildingsModalComponent } from "./building-group/remove-group-from-buildings-modal/remove-group-from-buildings-modal.component";
import { BuildingListModule } from "./building-list/building-list.module";
import { BuildingService } from "./building-list/services/building.service";
import { CreateBuildingModalComponent } from "./create-building-modal/create-building-modal.component";
import { DocumentListModule } from "./document-list/document-list.module";
import { FailedCommandModule } from "./failed-command/failed-command.module";
import { SurveyModule } from "./survey/survey.module";
import { WelcomeComponent } from "./welcome/welcome.component";
import { ImportBuildingsComponent } from "./admin-panel/import-buildings/import-buildings.component";
import { LomImportService } from "./admin-panel/services/lom-import.service";
import { CreateTemplateComponent } from "./admin-panel/templates-overview/create-template/create-template.component";
import { AdminPanelSettingsComponent } from "./admin-panel/admin-panel-settings/admin-panel-settings.component";
import { TabViewModule } from "primeng/tabview";
import { AdminPanelGeneralSettingsComponent } from "./admin-panel/admin-panel-settings/admin-panel-general-settings/admin-panel-general-settings.component";
import { GeneralSettingsService } from "./admin-panel/services/general-settings.service";
import { AdminPanelMaintenanceMessagesComponent } from "./admin-panel/admin-panel-maintenancemessages/admin-panel-maintenancemessages.component";
import { MaintenanceMessageService } from "./admin-panel/services/MaintenanceMessage.service";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgbNavModule,
    AuthModule,
    AppRoutingModule,
    FailedCommandModule,
    DocumentListModule,
    SurveyModule,
    BuildingListModule,
    CheckboxModule,
    DropdownModule,
    ChipsModule,
    ButtonModule,
    FileUploadModule,
    TabViewModule,
  ],
  declarations: [
    AdminPanelComponent,
    WelcomeComponent,
    AdminUsersComponent,
    AddUserComponent,
    AdminEditUserComponent,
    BuildingGroupSelectComponent,
    BuildingGroupAddBuildingToNewGroupComponent,
    BuildingGroupAddBuildingToGroupComponent,
    TemplatesOverviewComponent,
    AdminPanelUsersChildComponent,
    CreateBuildingModalComponent,
    AdminPanelCsvComponent,
    AdminPanelCsvExportFieldsComponent,
    AdminPanelBulkConfigurationComponent,
    AdminPanelBulkComponent,
    AdminPanelBulkUploadDialogComponent,
    AdminPanelFiberHoodContactsComponent,
    AdminPanelTriggerInitialLoadComponent,
    AdminPanelVerifyMftComponent,
    RemoveGroupFromBuildingsModalComponent,
    DeleteTemplateDialogComponent,
    OverrideTemplateDialogComponent,
    ImportBuildingsComponent,
    CreateTemplateComponent,
    AdminPanelSettingsComponent,
    AdminPanelGeneralSettingsComponent,
    AdminPanelMaintenanceMessagesComponent,
  ],
  exports: [WelcomeComponent, RouterModule],
  providers: [
    FormBuilder,
    UserService,
    BuildingService,
    CityListService,
    TemplateService,
    AreaContactService,
    BulkConfigurationService,
    BulkService,
    ExportFieldService,
    LomImportService,
    GeneralSettingsService,
    MaintenanceMessageService,
  ],
  entryComponents: [
    CreateBuildingModalComponent,
    BuildingGroupSelectComponent,
    BuildingGroupAddBuildingToGroupComponent,
    BuildingGroupAddBuildingToNewGroupComponent,
    RemoveGroupFromBuildingsModalComponent,
    DeleteTemplateDialogComponent,
    OverrideTemplateDialogComponent,
  ],
})
export class CoreModule {}
